<nav
  class="navbar navbar-expand-lg menu-header sticky-top"
  id="header"
  *ngIf="showHeader"
>
  <div class="container-fluid" *ngIf="!isB2BRoute && (topLevelDomainPage == 'ec' || isTestDomain)">
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed">
      <li class="fa fa-bars"></li>
    </button>
    <a
      class="btn-whatsapp mobile"
      rel="noopener noreferrer"
      (click)="contactEvent()"
      aria-label="redirección WhatsApp de ventas"
      target="_blank"
      [href]="linkWhats"
    >
      <img
        src="https://res.cloudinary.com/pervolare-org/image/upload/v1705335919/TAS/side-bar/wsp_mu5y4j.svg"
        alt="icon whatsapp"
      />
    </a>
    <button class="btn-red-header quote mobile">
            <a class="text-decoration-none" (click)="goToQuote()">COTIZAR GRATIS</a>
    </button>
    <span class="navbar-brand col-12 col-lg-2" routerLink="/"
      ><img
        class="pointer-event"
        id="brand"
        src="https://res.cloudinary.com/pervolare-org/image/upload/v1698425615/TAS/home/geop3aigtgwhisftzl7r.svg"
        alt="logo traveler assistance services"
        width="min-content"
        height="min-content"
    /></span>
    <div class="collapse navbar-collapse justify-content-end align-items-center col-10 row menu-options">
      <ul class="navbar-nav d-flex col-12">
        <li class="flex-fill nav-item">
          <a
            class="btn-whatsapp"
            rel="noopener noreferrer"
            (click)="contactEvent()"
            aria-label="redirección WhatsApp de ventas"
            target="_blank"
            [href]="linkWhats"
          >
            <img
              src="https://res.cloudinary.com/pervolare-org/image/upload/v1705335919/TAS/side-bar/wsp_mu5y4j.svg"
              alt="icon whatsapp"
            />
          </a>
        </li>
        <li class="flex-fill nav-item">
          <div ngbDropdown class="d-inline-block">
            <button
              type="button"
              class="dropdown-toggle btn btn-outline-primary text-blue"
              id="dropdownBasic1"
              routerLink="/planes"
            >
              Planes de asistencia
            </button>
          </div>
        </li>
        <li class="flex-fill nav-item">
          <div ngbDropdown class="d-inline-block">
            <button type="button" class="btn btn-outline-primary text-blue" id="dropdownBasic2" ngbDropdownToggle>
              Conócenos
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
              <button routerLink="/nosotros/por-que" ngbDropdownItem>Nosotros</button>
              <button routerLink="/contacto" ngbDropdownItem>Contacto</button>
              <a href="{{ urlBlog }}" target="_blank" class="text-decoration-none"
                ><button ngbDropdownItem>Blog</button></a
              >
            </div>
          </div>
        </li>
        <li class="flex-fill nav-item">
          <div ngbDropdown class="d-inline-block">
            <button type="button" class="btn btn-outline-primary text-blue" id="dropdownBasic3" ngbDropdownToggle>Ayuda</button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
              <button routerLink="/consulta" ngbDropdownItem>Consulta tu certificado</button>
              <button routerLink="/preguntas-frecuentes" ngbDropdownItem>Preguntas Frecuentes</button>
            </div>
          </div>
        </li>
        <li class="flex-fill nav-item">
          <button class="btn-blue-header button-emp" routerLink="/cotizador-de-proveedores">Quiero ser aliado</button>
        </li>
        <li class="flex-fill nav-item">
          <a [href]="linkFenix" target="_blank" class="text-decoration-none">
            <button class="btn-blue-header button-prov d-flex align-items-center">Soy aliado</button>
          </a>
        </li>
        <li class="flex-fill nav-item">
          <button class="btn-red-header quote desktop">
            <a class="text-decoration-none" (click)="goToQuote()"><b>COTIZAR GRATIS</b></a>
          </button>
        </li>
      </ul>
    </div>
  </div>
  <div class="container-fluid" *ngIf="isB2BRoute || (topLevelDomainPage != 'ec' && !isTestDomain)">
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed">
      <li class="fa fa-bars"></li>
    </button>
    <a [href]="linkFenix" target="_blank" class="text-decoration-none" id="soyaliado">
            <button
                type="button"
                class="btn btn-blue-header px-3 pt-1 pb-1"
              >
                Soy aliado
            </button>
    </a>
            <a
      class="btn-whatsapp mobile b2b"
      rel="noopener noreferrer"
      (click)="contactEvent()"
      aria-label="redirección WhatsApp de ventas"
      target="_blank"
      [href]="linkWhatsAppB2B"
    >
      <img
        src="https://res.cloudinary.com/pervolare-org/image/upload/v1705335919/TAS/side-bar/wsp_mu5y4j.svg"
        alt="icon whatsapp"
      />
    </a>
    <div class="container d-flex justify-content-between">
      <span
        *ngIf="isB2BRoute || (topLevelDomainPage != 'ec' && !isTestDomain)"
        class="navbar-brand col-12 col-lg-2"
        (click)="scrollToTop()"
        routerLink="/cotizador-de-proveedores"
        ><img
          class="pointer-event"
          src="https://res.cloudinary.com/pervolare-org/image/upload/v1698425615/TAS/home/geop3aigtgwhisftzl7r.svg"
          alt="logo traveler assistance services"
          width="min-content"
          height="min-content"
      /></span>
      <span *ngIf="!isB2BRoute && (topLevelDomainPage == 'ec' || isTestDomain)" class="navbar-brand col-12 col-lg-2" routerLink="/"
        ><img
          class="pointer-event"
          src="https://res.cloudinary.com/pervolare-org/image/upload/v1698435900/TAS/home/logo-tas-white_et6rf0.svg"
          alt="logo traveler assistance services"
          width="min-content"
          height="min-content"
      /></span>
      <div class="d-none d-lg-flex align-items-center col-lg-10">
        <ul class="navbar-nav d-flex col-12 justify-content-end">
          <li class="nav-item me-3">
            <a
              class="btn-whatsapp b2b"
              rel="noopener noreferrer"
              (click)="contactEvent()"
              aria-label="redirección WhatsApp de ventas"
              target="_blank"
              [href]="linkWhatsAppB2B"
            >
              <img
                src="https://res.cloudinary.com/pervolare-org/image/upload/v1705335919/TAS/side-bar/wsp_mu5y4j.svg"
                alt="icon whatsapp"
              />
            </a>
          </li>
          <li class="nav-item">
            <div ngbDropdown class="d-inline-block me-3 content-menu">
              <button
                type="button"
                class="dropdown-toggle btn btn-outline-primary"
                id="dropdownBasic1"
                (click)="scrollToSection('addSupplier')"
              >
                Quiero ser aliado
              </button>
            </div>
          </li>
          <li class="nav-item">
            <div ngbDropdown class="d-inline-block me-3 content-menu">
              <button
                type="button"
                class="dropdown-toggle btn btn-outline-primary"
                id="dropdownBasic1"
                routerLink="/planes-b2b"
              >
                Nuestros planes de asistencia
              </button>
            </div>
          </li>
          <li class="nav-item">
            <div ngbDropdown class="d-inline-block me-3 content-menu">
              <a [href]="linkFenix" target="_blank">
              <button
                type="button"
                class="dropdown-toggle btn btn-outline-primary"
                id="dropdownBasic1"
              >
                Soy aliado
              </button>
              </a>
            </div>
          </li>
          <li class="nav-item me-2">
            <a [href]="linkEmergency" target="_blank" class="text-decoration-none">
              <button class="btn-red-header">Reportar emergencia</button>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
<div class="container-mobile" [ngbCollapse]="isCollapsed" *ngIf="!isB2BRoute && (topLevelDomainPage == 'ec' || isTestDomain)">
  <div class="container-menu-mobile">
    <div class="menu-mobile">
      <div class="box-menu">
        <span class="title-menu-mobile"
          >MENÚ <b>TAS</b>
          <img
            class="close-menu"
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1698886700/TAS/home/close-menu_jj50gw.svg"
            (click)="isCollapsed = !isCollapsed"
            alt="boton cerrar"
        /></span>
      </div>
      <ngb-accordion [closeOthers]="true" class="text-primary text-center mt-5" id="acordion-menu-mobile">
        <ngb-panel id="menuOne" class="text-center">
          <ng-template ngbPanelTitle>
            <span routerLink="/planes" (click)="isCollapsed = !isCollapsed">Planes de asistencia</span>
          </ng-template>
        </ngb-panel>
        <ngb-panel id="menuTwo" title="Conócenos">
          <ng-template ngbPanelContent>
            <span class="submenu-mobile" routerLink="/nosotros/por-que" (click)="isCollapsed = !isCollapsed"
              >Nosotros</span
            ><br />
            <span class="submenu-mobile" routerLink="/contacto" (click)="isCollapsed = !isCollapsed">Contacto</span
            ><br />
            <a href="{{ urlBlog }}" target="_blank" class="text-decoration-none" (click)="isCollapsed = !isCollapsed"
              ><span class="submenu-mobile">Blog</span></a
            >
          </ng-template>
        </ngb-panel>
        <ngb-panel id="menuThree" title="Ayuda">
          <ng-template ngbPanelContent>
            <span class="submenu-mobile" routerLink="/consulta" (click)="isCollapsed = !isCollapsed"
              >Consulta tu certificado</span
            ><br />
            <span class="submenu-mobile" routerLink="/preguntas-frecuentes" (click)="isCollapsed = !isCollapsed"
              >Preguntas frecuentes</span
            ><br />
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      <div class="text-center">
        <button
          class="btn-blue-header mobile mt-5"
          routerLink="/cotizador-de-proveedores"
          (click)="isCollapsed = !isCollapsed"
        >
          Quiero ser aliado
        </button>
        <br>
        
        <a [href]="linkFenix" class="text-decoration-none">
            <button class="button-prov align-items-center" (click)="isCollapsed = !isCollapsed">Soy aliado</button>
            </a>
        <br />
          <button class="btn-red-header mobile mt-3">
            <a class="text-decoration-none" (click)="goToQuote();isCollapsed = !isCollapsed">COTIZAR GRATIS</a>
          </button>
      </div>
    </div>
  </div>
</div>
<div class="container-mobile" [ngbCollapse]="isCollapsed" *ngIf="isB2BRoute || (topLevelDomainPage != 'ec' && !isTestDomain)">
  <div class="container-menu-mobile-suplier">
    <button
    class="btn-close-menu"
    aria-label="Cerrar menú"
    (click)="isCollapsed = true">
    X
    </button>
    <div class="menu-mobile">
      <div class="text-center">
          <button class="btn-blue-header-mob mobile mt-4" (click)="scrollToSection('addSupplier');isCollapsed = !isCollapsed;">Quiero ser aliado</button>
          <button class="btn-blue-header-mob mobile mt-3" routerLink="planes-b2b" (click)="isCollapsed = !isCollapsed">Nuestros planes</button>
      </div>
    </div>
  </div>
</div>

<div id="ref"></div>
